import { BookBasedInspirationState, initialBookBasedState } from "./BookBasedInspiration/BookBasedInspirationState"
import { initialThemeBasedState, ThemeBasedInspirationState } from "./ThemeBasedInspiration/ThemeBasedInspirationState"
import { initialMoodBasedState, MoodBasedInspirationState } from "./MoodBasedInspiration/MoodBasedInspirationState"
import { initialLocationBasedState, LocationBasedInspirationState } from "./LocationBasedInspiration/LocationBasedInspirationState"
import { AdviceState, initialAdviceState } from "./Advice/AdviceState"

export type InspirationState = {
  bookBasedState: BookBasedInspirationState
  themeBasedState: ThemeBasedInspirationState
  moodBasedState: MoodBasedInspirationState
  locationBasedState: LocationBasedInspirationState
  adviceState: AdviceState
}

export const initialInspirationState: InspirationState = {
  bookBasedState: initialBookBasedState,
  themeBasedState: initialThemeBasedState,
  moodBasedState: initialMoodBasedState,
  locationBasedState: initialLocationBasedState,
  adviceState: initialAdviceState
}
